import { Check, TriangleAlert } from 'lucide-react';

import { useUiStore } from '@liniya/client-core';

/**
 * Transient feedback for actions that succeeded or failed.
 *
 * This replaces `alert()` and `confirm()`, which block the page, cannot be
 * styled, and on a phone look like the browser is warning about the site
 * rather than the site talking to its user.
 */
export function ToastHost() {
  const toasts = useUiStore((state) => state.toasts);
  const dismiss = useUiStore((state) => state.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={toast.tone === 'error' ? 'toast error' : 'toast'}
          onClick={() => dismiss(toast.id)}
        >
          {toast.tone === 'error' ? <TriangleAlert size={16} /> : <Check size={16} />}
          <span>{toast.text}</span>
        </button>
      ))}
    </div>
  );
}
